<template>
  <component :is="iconComponent" v-if="iconComponent" />
  <span v-else class="icon-fallback">{{ iconFallbackText }}</span>
</template>

<script setup lang="ts">
import type { IBaseIcon } from '@/common/components/base/BaseIcon/IBaseIcon.ts';
import { ref, watch, computed } from 'vue'
import * as LucideIcons from 'lucide-vue-next';

const props = defineProps<IBaseIcon>()
const iconComponent = ref<any>(null)
const iconFallbackText = computed(() => props.icon?.charAt(0) || '?')

async function loadIcon(iconName: string) {
  try {
    if (LucideIcons[iconName as keyof typeof LucideIcons]) {
      iconComponent.value = LucideIcons[iconName as keyof typeof LucideIcons]
      return
    }

    try {
      const module = await import(`@/assets/icons/${iconName}.svg`)
      iconComponent.value = module.default || module
    } catch (svgError) {
      iconComponent.value = null
    }
  } catch (error) {
    iconComponent.value = null
  }
}

watch(
  () => props.icon,
  (newIcon) => {
    if (newIcon) loadIcon(newIcon)
    else iconComponent.value = null
  },
  { immediate: true }
)

</script>